import { Component, OnInit } from '@angular/core';
import { ListService, PagedResultDto } from '@abp/ng.core';
import { EnumDto, OrderStatus } from '@proxy/enums';
import { GetOrderDto, OrderDto, OrderService } from '@proxy/orders';

interface Order {
  id: number;
  wineryName: string;
  status: string;
  itemCount: number;
  totalPrice: number;
  orderNumber: string;
}

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  standalone: false,
  providers: [ListService]
})
export class OrdersComponent implements OnInit {
  orders: Order[] = [];
  orderStatuses: EnumDto[] = [];
  orderStatusOptions: { label: string; value: number | null }[] = []; // lo que usa el select
  selectedStatus: number | null = null;
  searchOrder = {} as GetOrderDto;

  constructor(
    private orderService: OrderService,
    public readonly list: ListService
  ) {}

  ngOnInit(): void {
    // Cargar estados de órdenes
    this.orderService.getOrderStatuses().subscribe(res => {
      this.orderStatuses = res;

      this.orderStatusOptions = [
        ...this.orderStatuses.map(s => ({ label: s.name, value: s.value }))
      ];
    });

    const streamCreator = (query) => this.orderService.getOrdersByCurrentUser({ ...this.searchOrder, ...query });

    this.list.hookToQuery(streamCreator).subscribe((result: PagedResultDto<OrderDto>) => {
      // Mapear los resultados al formato que usa la UI
      this.orders = result.items.map(item => ({
        id: item.id,
        wineryName: item.userName || 'Unknown',
        status: this.formatOrderStatus(item.orderStatus),
        itemCount: item.itemCount || 0,
        totalPrice: item.total || 0,
        orderNumber: item.id.toString(),
        creationTime: item.creationTime
      }));
    });
  }

  onStatusChange(selected: number | null | undefined | string): void {
    const normalized =
      selected === null || selected === undefined || selected === '' ? null : selected;
    this.selectedStatus = normalized as number | null;
    this.searchOrder.orderStatus = this.selectedStatus;

    this.list.get();
  }

  private formatOrderStatus(status: OrderStatus | undefined): string {
    if (status === undefined) return 'Unknown';

    switch (status) {
      case OrderStatus.Pending:
        return '::OrderPending';
      case OrderStatus.Paid:
        return '::Paid';
      case OrderStatus.Shipped:
        return '::Shipped';
      case OrderStatus.Delivered:
        return '::Delivered';
      case OrderStatus.Cancelled:
        return '::Cancelled';
      default:
        return 'Unknown';
    }
  }
}
